<template>
  <div>
    <button class="btn btn-primary btn-sm"
        data-toggle="tooltip" 
        data-placement="top" 
        title="New"
        @click="fnShowModal()">New
    </button>

    <b-modal ref="modal" hide-footer title="Vehicle condition - new">
        <div class="d-block">
        <form v-on:submit.prevent="createNew">

            <div class="form-group">
                <label for="vCondition">Condition</label>
                <input type="text" 
                class="form-control" 
                id="vCondition" 
                placeholder="Condition"
                v-model="vCondition">
                <div class="invalid-feedback" v-if="errors.vCondition">{{ errors.vCondition[0] }}</div>
            </div>
        <hr>
        <div class="text-right">
            <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
            <button type="submit" class="btn btn-primary btn-sm">Save</button>
        </div>
        </form>
        </div>
    </b-modal>
  </div>
</template>
<script>
    import { mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as vehicleConditionService from '../../services/vehicleCondition.service';
    export default {
        name:"ModalVehicleConditionNew",
        components: {
            
        },
        data(){
            return{
                errors:{},
                vCondition:'',
            }
        },
        methods:{
            ...mapActions(['fetchVehicleConditionAll']),
            fnShowModal(){
                this.showModal();
            },
            hideModal(){
                this.$refs.modal.hide();
            },
            showModal(){
                this.$refs.modal.show();
            },

            createNew:async function(){
                const formData = new FormData();
                formData.append('vCondition',this.vCondition);
            try{
                await vehicleConditionService.add(formData);
                this.hideModal();
                this.fetchVehicleConditionAll();

                messageService.fnSweetAlertSuccessToast('Vehicle condition - new', 'added successfully');
                this.vCondition = '';

                }catch(error){
                    switch (error.response.status){
                    case 422:
                        this.errors = error.response.data.errors;
                        break;

                    case 500:
                        messageService.fnSweetAlertErrorToast('Vehicle condition - new', error.response.data.message);
                        break;

                    default:
                            messageService.fnSweetAlertErrorToast('Vehicle condition - new', 'Something wrong');
                        break;
                    }
                }
            },
        }
    }
</script>